module.exports = __webpack_public_path__ + "static/img/tc.4401c60b.svg";